export default __webpack_public_path__ + "static/media/StackOverflow.16658d2d.svg";